export enum FormStatus {
    Pending = 'pending',
    Success = 'success',
    Error = 'error',
    AdminRestrictedError = 'admin_restricted_error',
}
